import styled, { css } from "styled-components";
import { fontBold, fontNormal, defaultSize } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ borderLess }) =>
    !borderLess &&
    css`
      align-items: center;
    `};
  justify-content: center;
  padding: 8px 12px 8px 16px;
  border-radius: 4px;
`;

export const InfoWrapper = styled(MessageWrapper)`
  background-color: ${buildColor("blue", "000")};
`;

export const ErrorWrapper = styled(MessageWrapper)`
  background-color: ${buildColor("red", "subdued")};
  ${({ borderLess }) =>
    !borderLess &&
    css`
      border: 1px solid ${buildColor("red", "700")};
    `};

  & > div {
    margin-left: 0;
  }
`;

export const SuccessWrapper = styled(MessageWrapper)`
  background-color: ${buildColor("green", "000")};
  ${({ borderLess }) =>
    !borderLess &&
    css`
      border: 1px solid ${buildColor("green", "800")};
    `};
`;

export const WarningWrapper = styled(MessageWrapper)`
  padding: 8px 12px 8px 0;
  background-color: ${buildColor("orange", "subdued")};
  ${({ borderLess }) =>
    !borderLess &&
    css`
      border: 1px solid ${buildColor("yellow", "900")};
    `};

  span {
    color: ${buildColor("navy")};
  }

  svg {
    fill: ${buildColor("orange", "D2")};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  ${({ borderLess }) =>
    !borderLess
      ? css`
          width: 100%;
        `
      : css`
          margin-left: 16px;
        `};
  margin-bottom: ${({ size, hasSubText }) =>
    size === "big" && !hasSubText ? "16px" : "0"};
`;

export const LogoContainer = styled.span`
  display: flex;
  align-items: ${({ logoAtStart }) => (logoAtStart ? "flex-start" : "center")};
  align-self: flex-start;
  width: 20px;

  &:first-child {
    margin-right: 12px;
    ${({ logoAtStart }) =>
      logoAtStart &&
      css`
        margin-top: 2px;
      `};
  }
`;

export const TextContainer = styled.span`
  ${({ isCustomContainer }) =>
    !isCustomContainer &&
    css`
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: flex-start;
    `};
  color: ${({ textColor }) => textColor};
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  word-wrap: break-word;
  line-height: 125%;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ borderLess }) =>
    borderLess &&
    css`
      a:first-of-type {
        flex: 1;
        margin-right: 6px;
      }

      a:last-of-type {
        flex: 1;
        margin-left: 6px;
      }
      padding: 0 16px 0;
    `};
  margin-top: 20px;

  button:first-of-type,
  a:first-of-type {
    flex: 1;
  }

  button:last-of-type {
    flex: 1;
    margin-left: ${({ hasSecondaryButton }) => hasSecondaryButton && "12px"};
  }
`;

export const Title = styled.span`
  font-family: ${fontBold};
  font-size: ${defaultSize};
  font-weight: bold;
  letter-spacing: 0;
  line-height: 125%;
`;

export const SubTextLink = styled.a`
  font-family: ${fontBold};
  margin-top: 4px;
  font-weight: bold;
  color: ${buildColor("blue", "D1")};
  line-height: 125%;
`;
